class ProfileUsersController {
  static controller ($scope, ProfileService) {
    'ngInject';
    
    console.log('ProfileUsersController');

    var promise = ProfileService.getCurrentClientData();

    promise.then(function(data) {
      console.log('getCurrentClientData ok', data);
      $scope.userProfil = data;
    });

    $scope.updateProfile = function(){
      ProfileService.updateProfile($scope.userProfil).then(function(data) {
        console.log('updateProfile ok', data);
        $scope.success = true;
      }, function(reason) {
        console.error('updateProfile error', reason);
        $scope.success = false;
      });
    }
    
  };
}

export default ProfileUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/profile.users.controller.js